import axios from "axios";
import constant from "../utilities/constants.json";
import { setSiteUnderMaintenanceOutsideReact } from "../utilities/reducer";
let url = constant.server

const headers = {
    'Content-Type': 'application/json',
}

export const questions = (data) => {
    let token=''
    if (localStorage.webKey)
    {
       token= 'Bearer '+ `${localStorage.webKey}`
    }
    return axios
        .post(url + "get_questions",data,{
            headers: {  'Content-Type': 'application/json','time_zone':"Asia/Kolkata",Authorization:token},

        })
        .then((response) => {
            if (response.data.status == 1)
            {

                return response;
            }
            else if (response.data.status == 0 || response.data.status == 102 )
            {
                localStorage.clear()
                return response;

            }
            else if(response.data.status === 103)
                setSiteUnderMaintenanceOutsideReact()
            
        })
        .catch((err) => {
            console.log(err);
        });
};

